import { toast } from "react-toastify";

const initialState = {
  count: 0,
  fashionCount: 0,
};

const userVoteReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_VOTE_COUNT":
      return {
        ...state,
        count: action.payload,
      };
    case "SET_FASHION_VOTE_COUNT":
      return {
        ...state,
        fashionCount: Number(action.payload) || 0,
      };
    case "INCREMENT_VOTE":
      return {
        ...state,
        count: state.count + 1,
      };
    case "DCREMENT_VOTE":
      if (state.count == 1) {
        toast.info("You have used all free votes.");
      }
      return {
        ...state,
        count: state.count == 0 ? 0 : state.count - 1,
      };

    default:
      return state;
  }
};

export default userVoteReducer;
